<template>
    <!-- <app-layout> -->


        <div class="mb-14 mt-8">

            <div v-if="installType=='websdk'" class="text-xl font-bold text-center">Birdie web SDK</div>
            <div v-else class="text-xl font-bold text-center">Birdie code snippet</div>
            
            <div v-if="installType=='websdk'" class="text-center pt-4 pb-10">Open Birdie screen recorder from a specific button, link or element in your web app.</div>
            <div v-else class="text-center pt-4 pb-10">Install the code snippet to make the most of Birdie.<br /><span class="text-sm">Needed for Cobrowsing, and capturing console logs during Screen Recordings.</span></div>

            <div class="max-w-3xl mx-auto py-10 sm:px-6 lg:px-8 bg-white shadow sm:rounded-md">

                <installation-detail
                    :team_slug="team_slug"
                    :team_name="team_name"
                    :snippet_original="snippet_original"
                    :str_example1="str_example1"
                    :str_example2="str_example2"
                    :str_example3="str_example3"
                    :blur_snippet="blur_snippet"
                    :installType="installType"
                    :is_modal="false" />

            </div>



        </div>

</template>


<script>
    import AppLayout from '@/Layouts/AppLayout'

    import InstallationDetail from '@/Components/Settings/InstallationDetail'

    export default {
        props: [
            "team_slug","team_name", "snippet_encoded", "installType", "blur_snippet",
            "snippet_original","str_example1","str_example2","str_example3"
        ],
        components: {
            AppLayout, InstallationDetail
        },
        layout: AppLayout, // keep layout in place avoid refreshing it
        data() {
            return {

            }
        },
        created() {
            // this.EventBus.on("start.call", function(toto) {
            //     this.test(toto)
            // }.bind(this));
            //console.log(this.notify_inapp_video_received)
        },
        beforeUnmount() {
            // this.EventBus.off("start.call", this.test);
        },
        mounted() {
            // this.EventBus.emit("start.call", "hello")
        },
        methods: {
            // test(toto) {
            //     console.log("test ok", toto)
            // }
        }
    }
</script>
